//---------	Global imports
import React from 'react';

//---------	Plugins
import { filter, includes, forEach, throttle } from 'lodash';

//---------	Styles
import './styles.sass';

//---------	Translations
import { T } from '../../../translations';

//---------	Commons
import { matchHeight } from '../Shared/Commons'


class About extends React.Component {
  
  //---------	React functions
  componentDidMount() {
    setTimeout(this.throttledMatchHeight, 300);
    window.addEventListener('resize', this.throttledMatchHeight);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.throttledMatchHeight);
  }
  
  //---------	Custom functions
  throttledMatchHeight = throttle(this.aboutMatchHeight, 300);
  
  aboutMatchHeight() {
      matchHeight('.alt .CalipsyAbout-container')
  }
  
  
  //---------	Render
  render() {
    return (
      
      <div className="CalipsyAbout">
  
        <article className="CalipsyAbout-row history">
          <div className="CalipsyContainer">
            <div className="CalipsyAbout-container">
              <h2 dangerouslySetInnerHTML={{__html: T.about.historyTitle}}></h2>
              <div dangerouslySetInnerHTML={{__html: T.about.historyContent}}></div>
            </div>
          </div>
        </article>
        <article className="CalipsyAbout-row alt">
          <div className="CalipsyContainer">
            <div className="CalipsyAbout-container">
              <h2 dangerouslySetInnerHTML={{__html: T.about.whatWeDoTitle}}></h2>
              <p dangerouslySetInnerHTML={{__html: T.about.whatWeDoContent}}></p>
            </div>
            <div className="CalipsyAbout-container">
              <h2 dangerouslySetInnerHTML={{__html: T.about.missionTitle}}></h2>
              <p dangerouslySetInnerHTML={{__html: T.about.missionContent}}></p>
            </div>
          </div>
        </article>
        <article className="CalipsyAbout-row process">
          <div className="CalipsyContainer">
            <h2 dangerouslySetInnerHTML={{__html: T.about.process.title}}></h2>
          </div>
        </article>
        
        <section className="CalipsyAbout-process">
          <article>
            <div className="CalipsyContainer">
              <div className="CalipsyAbout-step">
                <div dangerouslySetInnerHTML={{__html: T.about.process.step1}}></div>
              </div>
            </div>
          </article>
          <article>
            <div className="CalipsyContainer">
              <div className="CalipsyAbout-step">
                <div dangerouslySetInnerHTML={{__html: T.about.process.step2}}></div>
              </div>
            </div>
          </article>
          <article>
            <div className="CalipsyContainer">
              <div className="CalipsyAbout-step">
                <div dangerouslySetInnerHTML={{__html: T.about.process.step3}}></div>
              </div>
            </div>
          </article>
          <article>
            <div className="CalipsyContainer">
              <div className="CalipsyAbout-step">
                <div dangerouslySetInnerHTML={{__html: T.about.process.step4}}></div>
              </div>
            </div>
          </article>
        </section>
      
      </div>
    );
  }
}

export default About;


// WEBPACK FOOTER //
// ./src/components/About/index.js